var exports = {
  "button": "Button.module__button___aXgyVU",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___aXgyVU",
  "small": "Button.module__small___aXgyVU",
  "compact": "Button.module__compact___aXgyVU",
  "superCompact": "Button.module__superCompact___aXgyVU",
  "fitContent": "Button.module__fitContent___aXgyVU",
  "fitContainer": "Button.module__fitContainer___aXgyVU",
  "square": "Button.module__square___aXgyVU",
  "stretched": "Button.module__stretched___aXgyVU",
  "primary": "Button.module__primary___aXgyVU",
  "secondary": "Button.module__secondary___aXgyVU",
  "danger": "Button.module__danger___aXgyVU",
  "inverted": "Button.module__inverted___aXgyVU",
  "invertedOutline": "Button.module__invertedOutline___aXgyVU",
  "ghost": "Button.module__ghost___aXgyVU",
  "recording": "Button.module__recording___aXgyVU",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___aXgyVU",
  "spinner": "Button.module__spinner___aXgyVU",
  "spinnerInner": "Button.module__spinnerInner___aXgyVU",
  "spinnerItem": "Button.module__spinnerItem___aXgyVU",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___aXgyVU",
  "iconWrapper": "Button.module__iconWrapper___aXgyVU",
  "spinnerWrapper": "Button.module__spinnerWrapper___aXgyVU",
  "hidden": "Button.module__hidden___aXgyVU",
  "grid": "Button.module__grid___aXgyVU",
};

__webpack_require__.r(module.exports = exports);
